var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Card } from '@philips-internal/oswald-ui-components';
import SelectionType from '@philips-internal/oswald-ui-constants/lib/selection-type';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import './pending-collection-exams-card.css';
import PendingCollectionExamsCardAPI from './pending-collection-exams-api';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types/event-listener';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let PendingCollectionExamsCard = class PendingCollectionExamsCard extends Component {
    constructor(props) {
        super(props);
        this.onChange = (event) => {
            const { onChange } = this.props;
            const cardValues = {
                dsObservacao: this.props.dsObservacao,
                dtPrevExecucao: this.props.dtPrevExecucao,
                ieRn: this.props.ieRn,
                ieUrgencia: this.props.ieUrgencia,
                nmExame: this.props.nmExame,
                nrSeqExame: this.props.nrSeqExame,
                nrSequencia: this.props.nrSequencia,
                statusAtend: this.props.statusAtend,
            };
            if (isFunction(onChange)) {
                onChange(new ChangeEvent({
                    value: {
                        card: cardValues,
                        checkbox: event,
                    },
                }));
            }
        };
        this.state = {
            ...props,
            showCheckbox: false
        };
    }
    static { this.propTypes = {
        onChange: eventListener,
        onClick: eventListener,
        onMount: eventListener,
    }; }
    render() {
        const { nrSequencia } = this.props;
        return (React.createElement(Card, { className: 'c-pending-collection-exams-card c-hidden-tap', selectionType: SelectionType.SINGLE, uuid: generateUUID(), width: 12, key: nrSequencia },
            React.createElement("div", { className: 'c-pending-collection-exams-card__wrapper' }, this.renderContent())));
    }
    renderContent() {
        const { nmExame, ieUrgencia, ieRn, dtPrevExecucao, dsObservacao } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'c-pending-collection-exams-card_wrap' },
                React.createElement("div", { className: 'c-pending-collection-exams-card__wrapper-left' },
                    React.createElement("h5", null, nmExame),
                    React.createElement("span", null, dtPrevExecucao)),
                React.createElement("div", { className: 'c-pending-collection-exams-card__wrapper-right' }, this.renderCheckBox())),
            this.renderUrgenciaRn(ieUrgencia, ieRn),
            this.renderDsObservacao(dsObservacao)));
    }
    renderUrgenciaRn(ieUrgencia, ieRn) {
        if ((ieUrgencia != null && ieUrgencia === 'S') || (ieRn != null && ieRn === 'S')) {
            return (React.createElement("div", { className: 'c-pending-collection-exams-card_wrap_b' },
                this.renderieUrgencia(ieUrgencia),
                this.renderIeRn(ieRn)));
        }
        return null;
    }
    renderCheckBox() {
        if (this.state.showCheckbox) {
            return (React.createElement("input", { type: "checkbox", id: "checkbox", name: "checkbox", onChange: (event) => this.onChange(event.target.checked) }));
        }
        return null;
    }
    renderDsObservacao(dsObservacao) {
        if (dsObservacao != null) {
            return (React.createElement("div", { className: "c-component-before-separator" },
                React.createElement("div", { className: "c-component-separator-pending-collection-exams-card" }),
                React.createElement("div", { className: 'c-pending-collection-exams-card__obs' },
                    React.createElement("a", null, dsObservacao))));
        }
        return null;
    }
    renderIeRn(ieRn) {
        if (ieRn != null && ieRn === 'S') {
            return (React.createElement("div", { className: 'c-pending-collection-exams-card__rn' },
                React.createElement("h4", null, "RN")));
        }
        return null;
    }
    renderieUrgencia(ieUrgencia) {
        if (ieUrgencia != null && ieUrgencia === 'S') {
            return (React.createElement("div", { className: 'c-pending-collection-exams-card__urgencia' },
                React.createElement("h4", null, MessageService.translate('$expression.$300864'))));
        }
        return null;
    }
};
PendingCollectionExamsCard = __decorate([
    AwesomeComponent({ api: PendingCollectionExamsCardAPI, type: ComponentType.DATA_DISPLAY }),
    __metadata("design:paramtypes", [Object])
], PendingCollectionExamsCard);
export default PendingCollectionExamsCard;
//# sourceMappingURL=pending-collection-exams-card.js.map